<template>


  <div class="children-container">
    <div class="children-module-name"><span>我的意向单</span></div>
    <div class="children-module-info">
      <a-table :columns="columns" :data-source="list" rowKey="id" :pagination="false">
        <template slot="unit_name" slot-scope="text, record">
          <span>{{ record['content_json']['unit_name'] }}</span>
        </template>
        <template slot="type" slot-scope="text, record">
          <span v-if="text == 'MODEL'">模型制作意向单</span>
          <span v-if="text == 'SNP'">SNP检测意向单</span>
          <span v-if="text == 'GENEDETECTION'">基因型检测意向单</span>
          <span v-if="text == 'EMBRYO'">胚胎操作实验意向单</span>
          <span v-if="text == 'STERILEMICE'">无菌小鼠业务客户意向单</span>
          <span v-if="text == 'CUSTOMBREEDING'">定制繁育业务客户意向单</span>
          <span v-if="text == 'PESTICIDEEFFECT'">功能药效部服务意向单</span>
          <span v-if="text == 'INSPECTION'">检测委托单</span>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-icon type="eye" style="margin-right: 10px;"/>
          <a @click.prevent="openDetail(record.id)" href="javascript:void(0)" target="_blank">详情</a>
        </template>
      </a-table>
      <div class="page-container">
        <a-pagination :hideOnSinglePage="true" :page-size.sync="page.pageSize" :total="page.totalRow"
                      v-model="page.start" @change="changePage"/>
      </div>
    </div>
    <a-modal dialogClass="custom-dialog" :maskClosable="false" v-model="detailVisible" title="详情" :footer="null"
             :width="1200" :destroyOnClose="true"
             :disabled="$store.state.requestLoading">
      <div style="max-height: 800px;overflow-y: scroll">
        <div v-if="detail && detail.type && detail.type == 'MODEL'">
          <intentioModel :detailInfo.sync="detail"/>
        </div>
        <div v-if="detail && detail.type && detail.type == 'SNP'">
          <intentioSnp :detailInfo.sync="detail"/>
        </div>
        <div v-if="detail && detail.type && detail.type == 'GENEDETECTION'">
          <intentioGenotype :detailInfo.sync="detail"/>
        </div>
        <div v-if="detail && detail.type && detail.type == 'EMBRYO'">
          <intentioEmbryo :detailInfo.sync="detail"/>
        </div>
        <div v-if="detail && detail.type && detail.type == 'STERILEMICE'">
          <intentioSterile :detailInfo.sync="detail"/>
        </div>
        <div v-if="detail && detail.type && detail.type == 'CUSTOMBREEDING'">
          <intentioCustomize :detailInfo.sync="detail"/>
        </div>
        <div v-if="detail && detail.type && detail.type == 'PESTICIDEEFFECT'">
          <intentioMedicine :detailInfo.sync="detail"/>
        </div>
        <div v-if="detail && detail.type && detail.type == 'INSPECTION'">
          <intentioCheck :detailInfo.sync="detail"/>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import * as Api from './api';
import * as commonApi from '@/commonApi';
export default {
  name: 'intentioBox',
  data() {

    return {
      list: [],
      page: {
        start: 1,
        limit: 20,
        pageSize: 0,
        totalRow: 0
      },
      flag: false,
      columns: [
        {
          title: "单位名称",
          dataIndex: "unit_name",
          scopedSlots: {customRender: "unit_name"},
        },
        {
          title: "类型",
          dataIndex: "type",
          scopedSlots: {customRender: "type"},
          width: 200
        },
        {
          title: "创建时间",
          dataIndex: "create_time",
          scopedSlots: {customRender: "create_time"},
          width: 200
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: {customRender: "action"},
          width: 100
        },
      ],
      detail: {},
      detailVisible: false,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 搜索
    search() {
      this.getList();
    },

    // 重置
    resetForm() {
    },

    // 时间
    changeTime(e, s) {
      this.start_time = s[0];
      this.end_time = s[1];
    },

    // 获取列表
    async getList() {
      let res = await Api.GetList(this.page);
      if (res && res["code"] == "0") {
        res.page.list.forEach(item => {
          item['content_json'] = JSON.parse(item['content_json']);
        })
        this.list = res.page.list;
        this.page.totalRow = res.page.totalRow;
        this.page.pageSize = res.page.pageSize;
        this.flag = true;
      }
    },
    // 改变分页
    changePage(e) {
      this.page.start = e;
      this.getList();
    },
    // 获取详情
    async getDetail(id) {
      let res = await Api.Detail({id: id});
      if (res && res["code"] == "0") {
        console.log(JSON.parse(res.target.content_json))
        res.target.content_json = JSON.parse(res.target.content_json);
        console.log(res.target.content_json)
        this.detail = res.target;
      }
    },
    // 打开详情弹框
    openDetail(id) {
      this.detailVisible = true;
      this.getDetail(id);
    }

  },
};
</script>

<style lang="less">
.flex {
  display: flex;
}

.cu-btn {
  border-bottom-left-radius: 10px;
  border-top-right-radius: 10px;
  height: 30px;
  padding: 0 25px;
}

.tips-text {
  font-size: 14px;
  font-weight: 500;
  color: #007F76;
  line-height: 38px;
  padding-top: 2px;
}

.children-module-content {
  padding: 25px !important;
}

.list {
  border: 1px solid #ECECEC;
  padding: 30px;
  display: flex;
  align-items: center;
}

.list .label {
  font-size: 12px;
  font-weight: 500;
  color: #333333;
  line-height: 30px;
  margin-right: 10px;
}

.list .info {
  flex: 1;
}

.list .action {
  width: 150px;
  display: flex;
  align-items: center;
  justify-content: flex-end
}

.list .default {
  font-size: 12px;
  font-weight: 500;
  text-decoration: underline;
  color: #008276;
  line-height: 30px;
  margin-left: 10px;
}

.list .name {
  font-size: 12px;
  color: #999999;
  line-height: 30px;
}

.inner-item {
  line-height: 20px;
}

.company-list {
  border: 1px solid #eee;
  font-size: 12px;
  overflow-y: scroll;
  max-height: 300px;
  position: absolute;
  background-color: #fff;
  z-index: 99999;
  width: 100%;
  font-weight: 600;
}

.company-item {
  line-height: 40px;
  border-bottom: 1px solid #eee;
  padding-left: 10px;
}

.company-list .company-item:hover {
  cursor: pointer;
  background: #F2F8F8;
}

.company-list .company-item:last-child {
  border-bottom: none;
}

.ant-table-tbody > tr > td {
  text-align: center;
}

.unit-box {
  display: flex;
  border-bottom: 1px solid #f5f5f5;
  padding: 6px 0;
  font-size: 12px;
}

.unit-item {

}

.unit-box .unit-item .content {
  margin-right: 40px;
  line-height: 24px;
}

.unit-box .unit-item:last-child .content {
  margin-right: 0;
}

.in-title {
  font-size: 16px;
  font-weight: bold;
  color: #008276;
  text-align: center;
  margin: 0 0 20px 0;
}

.sub-title {
  background-color: #f5f5f5;
  padding: 6px;
}

.in-box {
  border: 1px solid #eee;
  padding: 10px
}
</style>
